import {useMemo} from 'react';
import {assert} from 'assert-ts';
import {useLocalization} from 'localization';
import {isLinkedRoleCodeListId} from 'schemaDefinition';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';
import {AllCodeListIdsScopeMap} from 'schemaDefinition/types/linkTypes';
import {useAppSelector} from 'store/hooks';
import {getLinkedRoleCodelist} from 'schemas/links/functions';
import type {CodeListId, CodeListMap} from '../types';
import {selectCodelists} from '../codelistsSlice';

export function useCodelists(
  codelistIds: (CodeListId | LinkedRoleCodeListId)[],
): CodeListMap {
  const localization = useLocalization();
  const codelists = useAppSelector(selectCodelists);
  return useMemo(
    () =>
      codelistIds.reduce<CodeListMap>((acc, id) => {
        if (AllCodeListIdsScopeMap[id] === 'local') {
          return acc;
        }

        if (isLinkedRoleCodeListId(id)) {
          acc[id] = getLinkedRoleCodelist(id, localization);
          return acc;
        }

        acc[id] = assert(
          codelists[id]?.data,
          `useCodelists: codelist ${id} not loaded`,
        );

        return acc;
      }, {}),
    [codelistIds, codelists, localization],
  );
}
